import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "../item.css"

export const TimeFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    const handleInputChange = (value) => {
        // Extract time-only format (HH:mm:ss) for proper backend handling
        const isValid = value && dayjs(value).isValid();
        const timeValue = isValid ? dayjs(value).format('HH:mm:ss') : null;
        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: timeValue
            }
        });
    }

    return (
        <>
            <div className={`datetime-picker ${isDisabled ? "" : "enabled"}`}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker sx={{ marginTop: "7px" }}
                        ampm={false}
                        slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true }, fullWidth: true } }}
                        label={field.Captions[currentLanguage]?.length > 0 ? `${field.Captions[currentLanguage]}${field.IsMandatory ? '*' : ''}` : `${field.Code}${field.IsMandatory ? '*' : ''}`}
                        value={itemForm.form[field.Code] ? dayjs(itemForm.form[field.Code]) : null}
                        onChange={(e) => handleInputChange(e)}
                        disabled={isDisabled}
                    />
                </LocalizationProvider>
            </div>
        </>
    )
}
